import { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import AccountPage from './AccountPage';
import EditAccountPage from './Edit';
import ChangePasswordPage from './ChangePassword';
import PlanPage from './Plan';
import SetupAccountPage from './Setup';

const AccountRouter: FC = () => {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <AccountPage />
        </Route>
        <Route exact path={`${path}/setup`}>
          <SetupAccountPage />
        </Route>
        <Route exact path={`${path}/edit`}>
          <EditAccountPage />
        </Route>
        <Route exact path={`${path}/edit/password`}>
          <ChangePasswordPage />
        </Route>
        <Route exact path={`${path}/plan`}>
          <PlanPage />
        </Route>
      </Switch>
    </div>
  );
};

export default AccountRouter;
